import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { FaChevronDown, FaChevronUp, FaPlus } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addAttribute,
  deleteProductAttribute,
  getProductAttributes,
} from "../../../services/apis";

const ProductAttributes = () => {
  const [visibleSection, setVisibleSection] = useState("Manufacturing Details");
  const [currentModal, setCurrentModal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [usersData, setUsersData] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  const currentProductName = location.state?.productname;
  const currentCategoryName = location.state?.categoryname;
  const currentProductImage = location.state?.productimages;
  const productId = location.state?.productId;

  console.log("Currrrrr-->", currentProductName, currentCategoryName);

  // const queryParams = new URLSearchParams(location.search);
  // const productId = queryParams.get("productId");
  console.log("productId hi:", productId);

  const handleToggle = (section) => {
    setVisibleSection(visibleSection === section ? null : section);
  };

  const [modalData, setModalData] = useState({
    ProductSpecifications: [],
    PricingDetails: [],
    ManufacturingDetails: [],
    AuthenticationMethodUsed: [],
    AdditionalInformation: [],
  });

  const [formValues, setFormValues] = useState({
    type: "",
    label: "",
    value: "",
  });

  const [showModal1, setShowModal1] = useState(false);

  const handleModalClose1 = () => {
    setShowModal1(false);
    setFormValues({ type: "", label: "", value: "", dropdownType: "" });
    setCurrentModal(null);
  };

  const handleModalShow1 = (index) => {
    console.log("ind", index);

    setCurrentModal(index);
    setShowModal1(true);
  };

  const handleAddInput = (e) => {
    console.log("llll");

    e.preventDefault();
    console.log("curMod-->", currentModal);
    // where you calling it
    // any where else?
    //  you are using form
    // you need to prevent default behaviour
    const existingEntries = modalData[currentModal] || [];
    const apiEntries = usersData?.[currentModal] || [];
    const skipLabels = ["retail price", "final price", "currency code"];
    const allModalLabels = Object.values(modalData)
      .flat()
      .map((entry) => entry.label.trim().toLowerCase())
      .filter((label) => !skipLabels.includes(label));
    // .filter((label) => !skipLabels.includes(label));

    console.log("curExis1-->", existingEntries);
    console.log("curExis2-->", apiEntries);

    const allExistingLabels = [
      ...allModalLabels,
      ...apiEntries.map((entry) => entry.attrname.trim().toLowerCase()),
    ];

    console.log("curExis3-->", allExistingLabels);

    const isLabelExists = allExistingLabels.includes(
      formValues.label?.trim().toLowerCase()
    );
    if (!formValues.type?.trim()) {
      toast.dismiss();
      toast.error("Please select an Attribute Type.");
      return;
    }
    if (!formValues.label?.trim()) {
      toast.dismiss();
      toast.error("Attribute Label cannot be empty.");
      return;
    }
    if (isLabelExists) {
      console.log(
        `Label "${formValues.label}" already exists. Not adding duplicate.`
      );
      toast.dismiss();
      toast.error(
        "This attribute label already exists. Please use a different label."
      );
      return;
    }

    console.log(
      "formValues.value-->",
      formValues.type,
      formValues.label,
      formValues.value
    );

    const getInitialValue = (type) => {
      switch (type) {
        case "boolean":
          return false;
        case "number":
        case "decimal":
          return "";
        case "text":
        case "date":
          return "";
        default:
          return "";
      }
    };

    const newAttribute = {
      type: formValues.type,
      label: formValues.label,
      value: getInitialValue(formValues.type),
      dropdownType: formValues.dropdownType,
    };

    // Ensure we're appending the new attribute data without replacing anything
    const updatedData = {
      ...modalData,
      [currentModal]: [...existingEntries, newAttribute],
    };

    if (
      formValues.retailprice ||
      formValues.finalprice ||
      formValues.currencycode
    ) {
      const updatedPricingDetails = [
        ...(modalData?.PricingDetails || []),
        ...(formValues.retailprice
          ? [
              {
                label: "Retail Price",
                value: formValues.retailprice,
                type: "number",
              },
            ]
          : []),
        ...(formValues.finalprice
          ? [
              {
                label: "Final Price",
                value: formValues.finalprice,
                type: "number",
              },
            ]
          : []),
        ...(formValues.currencycode
          ? [
              {
                label: "Currency Code",
                value: formValues.currencycode,
                type: "text",
              },
            ]
          : []),
      ];

      modalData.PricingDetails = updatedPricingDetails;
    }
    console.log("updatedData", updatedData);
    setModalData(updatedData);
    setFormValues({
      type: "",
      label: "",
      value: "",
      retailprice: "",
      finalprice: "",
      currencycode: "",
      dropdownType: "",
    });

    if (typeof handleModalClose1 === "function") {
      handleModalClose1();
    }
  };

  const handleSubmit = async () => {
    try {
      const hasEmptyManufacturing = modalData.ManufacturingDetails?.some(
        (item) => !item.value?.toString().trim()
      );
      const hasEmptyProductSpecifications =
        modalData.ProductSpecifications?.some(
          (item) => !item.value?.toString().trim()
        );
      const hasEmptyPricingDetails = modalData.PricingDetails?.some(
        (item) => !item.value?.toString().trim()
      );
      const hasEmptyAuthenticationMethodUsed =
        modalData.AuthenticationMethodUsed?.some(
          (item) => !item.value?.toString().trim()
        );
      const hasEmptyAdditionalInfo = modalData.AdditionalInformation?.some(
        (item) => !item.value?.toString().trim()
      );

      if (
        hasEmptyManufacturing ||
        hasEmptyProductSpecifications ||
        hasEmptyPricingDetails ||
        hasEmptyAuthenticationMethodUsed ||
        hasEmptyAdditionalInfo
      ) {
        toast.dismiss();
        toast.error("Please fill out missing inputs.");
        return;
      }
      const updatedPricingDetails = [
        ...(modalData.PricingDetails || []),
        ...(formValues.retailprice
          ? [
              {
                label: "Retail Price",
                value: formValues.retailprice,
                type: "number",
              },
            ]
          : []),
        ...(formValues.finalprice
          ? [
              {
                label: "Final Price",
                value: formValues.finalprice,
                type: "number",
              },
            ]
          : []),
        ...(formValues.currencycode
          ? [
              {
                label: "Currency Code",
                value: formValues.currencycode,
                type: "text",
              },
            ]
          : []),
      ];

      const dataToSend = {
        ...modalData,
        PricingDetails: updatedPricingDetails,
      };

      const response = await addAttribute(dataToSend, productId);

      if (response && response.statuscode === 1) {
        toast.dismiss();
        toast.success(response.message);
        fetchAttributes();
        setModalData({
          ProductSpecifications: [],
          PricingDetails: [],
          ManufacturingDetails: [],
          AuthenticationMethodUsed: [],
          AdditionalInformation: [],
        });
        setFormValues({
          retailprice: "",
          finalprice: "",
          currencycode: "",
        });
      } else {
        toast.dismiss();
        toast.error(response.message);
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Failed to submit data!");
    }
  };

  const fetchAttributes = async () => {
    // setIsLoading(true);
    if (!productId) {
      console.error("Product ID is missing!");
      return;
    }
    const response = await getProductAttributes(productId);
    setIsLoading(false);
    if (response && response.statuscode === 1) {
      // setUsersData(response.data);

      setModalData({
        ManufacturingDetails: Object.entries(
          response.data.ManufacturingDetails
        ).map(([key, value]) => ({
          AttributeId: value.attrId,
          label: value.attrname,
          value: value.attrvalue,
          type: value.type,
          dropdownType: "ManufacturingDetails",
        })),
        ProductSpecifications: Object.entries(
          response.data.ProductSpecification
        ).map(([key, value]) => ({
          AttributeId: value.attrId,
          label: value.attrname,
          value: value.attrvalue,
          type: value.type,
          dropdownType: "ProductSpecifications",
        })),
        PricingDetails: Object.entries(response.data.PricingDetails).map(
          ([key, value]) => ({
            AttributeId: value.attrId,
            label: value.attrname,
            value: value.attrvalue,
            type: value.type,
            dropdownType: "PricingDetails",
          })
        ),
        AuthenticationMethodUsed: Object.entries(
          response.data.AuthenticationMethodUsed
        ).map(([key, value]) => ({
          AttributeId: value.attrId,
          label: value.attrname,
          value: value.attrvalue,
          type: value.type,
          dropdownType: "AuthenticationMethodUsed",
        })),
        AdditionalInformation: Object.entries(
          response.data.AdditionalInformation
        ).map(([key, value]) => ({
          AttributeId: value.attrId,
          label: value.attrname,
          value: value.attrvalue,
          type: value.type,
          dropdownType: "AdditionalInformation",
        })),
      });
      return;
    }
  };

  useEffect(() => {
    console.log("==enterrrrrr==");
    fetchAttributes();
  }, []);

  const handleValueChange = (section, index, newValue) => {
    console.log("section==>", section, index, newValue);

    const updatedDetails = modalData[section]?.map((item, i) =>
      i === index ? { ...item, value: newValue } : item
    );
    setModalData((prev) => ({ ...prev, [section]: updatedDetails }));
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault(); // Prevent form submission or navigation
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleDelete = async (dropdownType, attrId, labelToDelete) => {
    console.log("dropdownType==>", dropdownType, attrId);

    // const sectionKey = Object.keys(modalData).find(
    //   (key) => formatKeyName(key) === dropdownType
    // );

    // if (!sectionKey) return;

    // Step 2: If attrId is missing (i.e., unsaved), just remove locally
    if (!attrId) {
      setModalData((prevData) => {
        const updatedData = { ...prevData };
        const currentList = updatedData[dropdownType] || [];

        if (dropdownType === "Manufacturing Details") {
          updatedData.ManufacturingDetails = Array.isArray(
            updatedData.ManufacturingDetails
          )
            ? updatedData.ManufacturingDetails.filter(
                (item) => item.attrId !== attrId
              )
            : [];
        } else if (dropdownType === "Product Specification") {
          updatedData.ProductSpecifications = Array.isArray(
            updatedData.ProductSpecifications
          )
            ? updatedData.ProductSpecifications.filter(
                (item) => item.attrId !== attrId
              )
            : [];
        } else if (dropdownType === "Pricing Details") {
          updatedData.PricingDetails = Array.isArray(updatedData.PricingDetails)
            ? updatedData.PricingDetails.filter(
                (item) => item.attrId !== attrId
              )
            : [];
        } else if (dropdownType === "Authentication Method Used") {
          updatedData.AuthenticationMethodUsed = Array.isArray(
            updatedData.AuthenticationMethodUsed
          )
            ? updatedData.AuthenticationMethodUsed.filter(
                (item) => item.attrId !== attrId
              )
            : [];
        } else if (dropdownType === "Additional Information") {
          updatedData.AdditionalInformation = Array.isArray(
            updatedData.AdditionalInformation
          )
            ? updatedData.AdditionalInformation.filter(
                (item) => item.attrId !== attrId
              )
            : [];
        }
        updatedData[dropdownType] = (updatedData[dropdownType] || []).filter(
          (item) => item.label !== labelToDelete
        );
        return updatedData;
      });

      toast.dismiss();
      toast.success("Unsaved attribute removed.");
      return;
    }

    try {
      const result = await deleteProductAttribute({
        dropdownType,
        AttributeId: attrId,
      });

      if (result?.statuscode === 1) {
        setModalData((prevData) => {
          const updatedData = { ...prevData };

          updatedData[dropdownType] = (updatedData[dropdownType] || []).filter(
            (item) => item.attrId !== attrId
          );

          return updatedData;
        });

        toast.dismiss();
        toast.success(result.message || "Attribute deleted successfully.");
        fetchAttributes();
      } else {
        toast.dismiss();
        toast.error(result?.message || "Failed to delete attribute.");
      }
    } catch (error) {
      console.error("Error deleting attribute:", error);
      toast.dismiss();
      toast.error("An error occurred while deleting the attribute.");
    } finally {
      setIsLoading(false);
    }
  };
  const formatKeyName = (key) => {
    return key
      ?.replace(/([a-z])([A-Z])/g, "$1 $2") // Add a space before uppercase letters
      ?.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  return (
    <div className="p-4">
      <ToastContainer />
      <div
        className="p-3 rounded d-flex justify-content-between w-100 align-items-center shadow"
        style={{ backgroundColor: "#F7F7F8" }}
      >
        <div className="d-flex w-50 gap-3">
          {/* <div> */}
          <div
            style={{ width: 80, height: 80 }}
            className="bg-gray-400 rounded"
          >
            <img
              src={currentProductImage}
              style={{ width: "100%", height: "100%" }}
              className="rounded"
            />
          </div>
          <div className="w-100 d-flex flex-column justify-content-center align-items-start">
            <h4 style={{ color: "#262B40", fontWeight: "bold" }}>
              {currentProductName || "XXX"}
            </h4>
            <h6 style={{ color: "#262B40" }}>{currentCategoryName || "XXX"}</h6>
          </div>
        </div>
      </div>

      <div className="m-4 d-flex flex-column gap-3">
        {Object.keys(modalData).map((index) => (
          <div className="card">
            <div
              className="card-header bg-light d-flex justify-content-between align-items-center"
              onClick={() => handleToggle(index)}
              style={{ cursor: "pointer" }}
            >
              <span>{formatKeyName(index)}</span>
              {visibleSection === index ? <FaChevronUp /> : <FaChevronDown />}
            </div>

            {visibleSection === index && (
              <div className="card-body">
                <div>
                  <ul className="list-group">
                    {index === "PricingDetails" && (
                      <div className="w-full mb-3">
                        {["Retail Price", "Final Price", "Currency Code"].map(
                          (attr) =>
                            !modalData[index].find(
                              (item) => item.label === attr
                            ) && (
                              <li
                                className="list-group-item d-flex flex-column"
                                key={attr}
                              >
                                <Form.Group className="w-100">
                                  <Form.Label>{attr}</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder={`Enter ${attr}`}
                                    maxLength={10}
                                    value={
                                      formValues[
                                        attr.toLowerCase().replace(" ", "")
                                      ] || ""
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (attr === "Currency Code") {
                                        // Allow only letters and spaces for Currency Code (text)
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                          setFormValues((prev) => ({
                                            ...prev,
                                            [attr
                                              .toLowerCase()
                                              .replace(" ", "")]: value,
                                          }));
                                        }
                                      } else {
                                        // Allow only numbers for other fields (number)
                                        if (/^\d*$/.test(value)) {
                                          setFormValues((prev) => ({
                                            ...prev,
                                            [attr
                                              .toLowerCase()
                                              .replace(" ", "")]: value,
                                          }));
                                        }
                                      }
                                    }}
                                  />
                                </Form.Group>
                              </li>
                            )
                        )}
                      </div>
                    )}
                    {modalData[index].map((item, index) => (
                      <>
                        <li
                          key={index}
                          className="list-group-item d-flex flex-column"
                          style={{ alignItems: "start" }}
                        >
                          <div>{item.label}</div>
                          <div
                            className="d-flex w-100"
                            style={{ alignItems: "end" }}
                          >
                            {item.type === "date" ? (
                              <Datetime
                                inputProps={{
                                  placeholder: "dd-mm-yyyy",
                                  className: "form-control mt-2",
                                  onKeyPress: (e) => {
                                    if (/[a-zA-Z]/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  },
                                }}
                                value={item.value}
                                onChange={(date) =>
                                  handleValueChange(
                                    item.dropdownType,
                                    index,
                                    moment(date).format("YYYY-MM-DD")
                                  )
                                }
                                dateFormat="DD-MM-YYYY"
                                timeFormat={false}
                                className="w-100 "
                              />
                            ) : item.type === "boolean" ? (
                              <div
                                className="btn-group mt-2 w-100"
                                role="group"
                              >
                                <input
                                  type="radio"
                                  className="btn-check"
                                  name={`boolean-${index}`}
                                  id={`yes-${index}`}
                                  value="true"
                                  checked={item.value === true}
                                  onChange={() =>
                                    handleValueChange(
                                      item.dropdownType,
                                      index,
                                      true
                                    )
                                  }
                                />
                                <label
                                  className="btn btn-outline-primary"
                                  htmlFor={`yes-${index}`}
                                  style={{ width: "50%" }}
                                >
                                  Yes
                                </label>

                                <input
                                  type="radio"
                                  className="btn-check"
                                  name={`boolean-${index}`}
                                  id={`no-${index}`}
                                  value="false"
                                  checked={item.value === false}
                                  onChange={() =>
                                    handleValueChange(
                                      item.dropdownType,
                                      index,
                                      false
                                    )
                                  }
                                />
                                <label
                                  className="btn btn-outline-primary"
                                  htmlFor={`no-${index}`}
                                  style={{ width: "50%" }}
                                >
                                  No
                                </label>
                              </div>
                            ) : (
                              <Form.Control
                                type="text"
                                placeholder={`Enter ${item.type}`}
                                value={item.value ?? ""}
                                onChange={(e) => {
                                  let newValue = e.target.value;
                                  if (item.type === "number") {
                                    // For "number" type: only allow digits
                                    if (
                                      newValue === "" ||
                                      /^\d*$/.test(newValue)
                                    ) {
                                      handleValueChange(
                                        item.dropdownType,
                                        index,
                                        newValue
                                      );
                                    }
                                  } else if (item.type === "decimal") {
                                    // For "decimal" type: allow digits and only one dot
                                    if (
                                      /^\d*\.?\d*$/.test(newValue) &&
                                      newValue.split(".").length <= 2 // Valid decimal (one dot)
                                    ) {
                                      handleValueChange(
                                        item.dropdownType,
                                        index,
                                        newValue
                                      );
                                    }
                                  } else {
                                    // For "text" type: allow anything
                                    handleValueChange(
                                      item.dropdownType,
                                      index,
                                      newValue
                                    );
                                  }
                                }}
                                className="w-100 mt-2"
                                maxLength={
                                  (item.label === "Retail Price" ||
                                    item.label === "Final Price" ||
                                    item.label === "Currency Code") &&
                                  10
                                }
                              />
                            )}
                            {item.label === "Retail Price" ||
                            item.label === "Final Price" ||
                            item.label === "Currency Code" ? null : (
                              <Button
                                variant="danger"
                                size="sm"
                                style={{
                                  marginLeft: "10px",
                                  height: 35,
                                  width: 35,
                                  marginBottom: 5,
                                }}
                                onClick={() => {
                                  handleDelete(
                                    item.dropdownType,
                                    item.AttributeId,
                                    item.label
                                  );
                                  console.log("Clickeddd");
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                            )}
                          </div>
                        </li>
                      </>
                    ))}
                  </ul>
                </div>
                <div className="mt-2">
                  <Button
                    variant="primary"
                    className="text-white bg-gradient"
                    onClick={() => handleModalShow1(index)}
                  >
                    <FaPlus className="me-2" />
                    Add Attribute
                  </Button>
                </div>
              </div>
            )}

            <Modal show={currentModal === index} onHide={handleModalClose1}>
              <Modal.Header closeButton>
                <Modal.Title>{formatKeyName(index)}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="type">
                    <Form.Label>Attribute Type</Form.Label>
                    <Form.Select
                      name="type"
                      value={formValues.type}
                      onChange={(e) =>
                        setFormValues((prev) => ({
                          ...prev,
                          type: e.target.value,
                          dropdownType: index,
                        }))
                      }
                    >
                      <option value="">Select Attribute Type</option>
                      <option value="text">Text</option>
                      <option value="number">Number</option>
                      <option value="decimal">Decimal</option>
                      <option value="date">Date</option>
                      <option value="boolean">Boolean</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group controlId="label" className="mt-3">
                    <Form.Label>Attribute Label</Form.Label>
                    <Form.Control
                      type="text"
                      name="label"
                      placeholder="Enter attribute label"
                      value={formValues.label}
                      onChange={(e) =>
                        setFormValues((prev) => ({
                          ...prev,
                          label: e.target.value,
                          dropdownType: index,
                        }))
                      }
                      maxLength={50}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="text-white bg-gradient"
                  type="button"
                  onClick={(e) => handleAddInput(e)}
                >
                  Add Input
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        ))}

        <div className="d-flex justify-content-end gap-2">
          <Button
            variant="default"
            style={{ color: "#9EDB6B", border: "1px solid #9EDB6B" }}
            className="px-3"
            onClick={() => navigate(-1)}
          >
            Close
          </Button>
          <Button
            variant="primary"
            className="text-white"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ProductAttributes;
